<template>
  <div style="position: relative">
    <a-icon class="a-icon" type="plus-circle"/>
    <div class="ant-input" @click="openModal" v-if="!disabled">
      <template v-for="tag in ids">
        <a-tooltip :key="tag.tagId" :title="tag.tagName">
          <a-tag :key="tag.tagId" :closable="true" @close="() => tagClose(tag)" style="margin: 3px">
            {{ tag.tagName }}
          </a-tag>
        </a-tooltip>
      </template>
      <a-tooltip :key="1000001" :title="`删除全部`">
        <a-tag :key="1000001" @click.stop="closeAll" style="margin: 3px" :visible="ids.length > 0">
          删除全部
        </a-tag>
      </a-tooltip>
    </div>
    <div class="ant-input" style="height: auto;min-height: 32px;background-color: #eee" v-else>
      <template v-for="tag in list">
        <a-tooltip :key="tag.tagId" :title="tag.tagName">
          <a-tag :key="tag.tagId" :closable="false" @close="() => tagClose(tag)" style="margin: 3px">
            {{ tag.tagName }}
          </a-tag>
        </a-tooltip>
      </template>
    </div>
    <a-modal forceRender
             v-model="visible"
             :title="title"
             :width="1200"
             ok-text="确认"
             cancel-text="取消"
             @ok="handleOk"
    >
      <div class="tag-select">
        <div class="tag-menu">
          <a-menu
              style="width: 200px"
              :defaultOpenKeys="[1]"
              mode="inline"
              :selectable="false"
              @click="handleClick"
          >
            <a-sub-menu :key="1">
              <span slot="title"><span>SCRM标签</span></span>
              <a-menu-item v-for="item in tagList" :key="item.groupId">
                {{ item.groupName }}
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </div>
        <ul class="tag-list">
          <li>
            <ul class="child-list">
              <li v-for="child in tagList" :key="child.groupId" :class="`group${child.groupId}`">
                <h4>{{ child.groupName }}</h4>
                <ul>
                  <li v-for="tag in child.tagList" :key="tag.tagId" :class="{active : tag.checked}"
                      @click="tag.checked = !tag.checked">
                    {{ tag.tagName }}
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </a-modal>
  </div>

</template>

<script>
import {dataApi} from '@/services/comm/tagPicker.js';

export default {
  data() {
    return {
      visible: false,
      list: [],
      ids: [],
      tagList: [],
    };
  },
  model: {
    prop: 'value',
    event: 'rtValue'
  },
  watch: {
    ids: {
      immediate: true,
      handler: function () {

      }
    }
  },
  props: {
    title: {
      type: String
    },
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.getScrmTagList()
  },
  methods: {
    openModal() {
      this.showSelected()
      this.visible = true
    },
    handleOk() {
      let ids = []
      this.tagList.forEach(item => {
        item.tagList.forEach(child => {
          if (child.checked) {
            ids.push({tagId: child.tagId, tagName: child.tagName})
          }
        })
      })
      this.ids = ids
      this.$emit('rtValue', this.ids.map(item => {
        return item.tagId
      }).toString())
      this.visible = false;
    },
    showSelected() {
      let ids = this.value ? this.value.split(',') : []
      let arr = []
      this.tagList.forEach(item => {
        item.tagList.forEach(tag => {
          tag.checked = ids.includes(`${tag.tagId}`)
          if (tag.checked) {
            arr.push({tagId: tag.tagId, tagName: tag.tagName})
          }
        })
      })
      this.ids = arr
    },
    tagClose(removedTag) {
      this.ids = this.ids.filter(tag => tag !== removedTag);
      this.$emit('rtValue', this.ids.map(item => {
        return item.tagId
      }).toString())
    },
    closeAll() {
      this.ids = []
      this.$emit('rtValue', '')
    },
    handleClick(e) {
      document.getElementsByClassName('group' + e.key)[0].scrollIntoView({
        behavior: 'smooth', block: 'center'
      })
    },
    getScrmTagList() {
      dataApi.getScrmTagList().then(res => {
        this.tagList = res.data.map(item => {
          if (item.tagList) {
            item.tagList.forEach(item1 => {
              item1.checked = false
            })
          }
          return item
        })
        this.showSelected()
      })
    }
  },
};
</script>
<style scoped lang="less">
.ant-input {
  height: auto;
  min-height: 32px;
  min-width: 200px;
}

.a-icon {
  position: absolute;
  z-index: 10;
  right: 6px;
  top: 13px;
  pointer-events: none;
}

input {
  cursor: pointer
}

.tag-select {
  display: flex;
  max-height: 700px;
  overflow: hidden;
  //border: 1px solid #999;
  margin-top: 24px;

  ul {
    list-style-type: none;
  }

  .tag-menu {
    width: 200px;
  }

  .tag-list {
    overflow-y: scroll;
    flex: 1;
    border-left: 1px solid #999;

    .child-list {
      padding-left: 0;

      h4 {
        color: #333;
        font-weight: bold;
        margin-top: 24px;
      }

      ul {
        padding-left: 0;

        li {
          display: inline-block;
          background-color: #E9F5FC;
          color: #3DA2FB;
          border-radius: 8px;
          padding: 8px 24px;
          margin: 4px;
          cursor: pointer;

          &.active {
            background-color: #3DA2FB;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>

